module.exports = __webpack_public_path__ + "img/2ezBanner2Mobile.0ecdc781.jpg";